import { getLatestDocumentExportByType } from '@/api/basecamp.api';
import type { DocumentExportType, IDocumentExport } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import { ref } from 'vue';

export const useDocumentExport = (type: DocumentExportType) => {
    const documentExport = ref<IDocumentExport>(null);

    const queryResult = useQuery(['document-exports', 'type', type], async (): Promise<IDocumentExport> => getLatestDocumentExportByType(type), {
        initialData: null,
        onSuccess: data => {
            documentExport.value = data;
        },
    });

    return { ...queryResult };
};
